<template>
  <v-layout row justify-center>
    <v-dialog v-model="showNewNotification" max-width="630px"
      transition="dialog-bottom-transition" @keydown.esc="showNewNotification = false">
      <v-card>
        <v-toolbar color="blue-grey lighten-5">
          <v-spacer></v-spacer>
          <v-toolbar-title class="text-xs-center">NOVA NOTIFICAÇÃO</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.stop="showNewNotification = false">
            <v-icon>fal fa-times</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12>
                <v-text-field label="Título" v-model="notification.title" outline required></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field label="Mensagem" v-model="notification.message" outline required></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field label="URL" v-model="notification.url" outline required></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click.stop="send()" round large depressed color="success" :loading="loadingRequest">
            Enviar
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import axios from 'axios'
import EventBus from '@/event-bus'

export default {
  data: () => ({
    showNewNotification: false,
    loadingRequest: false,
    notification: {}
  }),

  methods: {
    send () {
      this.loadingRequest = true

      // eslint-disable-next-line
      axios.post(`${API.notifications}/users`, this.notification).then(response => {
        this.showNewNotification = false
        EventBus.$emit('loadNotifications')

        EventBus.$emit('showSnackbar', {
          message: 'Notificação enviada com sucesso!',
          color: 'success'
        })

        this.loadingRequest = false
      }).catch(errors => {
        this.loadingRequest = false
        EventBus.$emit('showSnackbar', {
          message: 'Erro ao criar a notificação',
          color: 'error'
        })
      })
    }
  },

  beforeDestroy () {
    EventBus.$off('showNewNotification')
    EventBus.$off('showNewNotificationData')
  },

  mounted () {
    EventBus.$on('showNewNotification', data => {
      this.showNewNotification = data
    })

    EventBus.$on('showNewNotificationData', data => {
      this.notification = data
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/admin/notifications/AdminNotificationsNew.vue